import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpdeskRulesAPI } from "../../../../api/helpdeskRules";

export default function RulesList() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  async function loadRules() {
    try {
      const data = await HelpdeskRulesAPI.list();
      setRules(data.rules || []);
    } finally {
      setLoading(false);
    }
  }

  async function toggleRule(rule) {
    if (rule.enabled) {
      await HelpdeskRulesAPI.disable(rule.id);
    } else {
      await HelpdeskRulesAPI.enable(rule.id);
    }

    loadRules();
  }

  async function deleteRule(rule) {
    if (!window.confirm(`Delete rule "${rule.name}"?`)) {
      return;
    }

    await HelpdeskRulesAPI.delete(rule.id);
    loadRules();
  }

  useEffect(() => {
    loadRules();
  }, []);

  if (loading) {
    return <div>Loading rules…</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold">Rules</h2>
          <p className="text-sm text-gray-600 mt-1">
            Automatically perform actions when helpdesk events meet defined
            conditions.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate("/helpdesk/automation/rules/new")}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          New rule
        </button>
      </div>

      {rules.length === 0 ? (
        <div className="border rounded p-6 text-sm text-gray-600">
          No automation rules have been created yet.
        </div>
      ) : (
        <div className="border rounded overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Trigger</th>
                <th className="p-3 text-left">Scope</th>
                <th className="p-3 text-center">Enabled</th>
                <th className="p-3 text-right">Actions</th>
              </tr>
            </thead>

            <tbody>
              {rules.map((rule) => (
                <tr
                  key={rule.id}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="p-3">
                    <button
                      type="button"
                      className="text-blue-600 hover:underline text-left"
                      onClick={() =>
                        navigate(
                          `/helpdesk/automation/rules/${rule.id}`
                        )
                      }
                    >
                      {rule.name}
                    </button>

                    {rule.description && (
                      <div className="text-xs text-gray-500 mt-1">
                        {rule.description}
                      </div>
                    )}
                  </td>

                  <td className="p-3 text-sm">
                    {rule.event_type}
                  </td>

                  <td className="p-3 text-sm">
                    {rule.scope_type}
                  </td>

                  <td className="p-3 text-center">
                    <input
                      type="checkbox"
                      checked={Boolean(rule.enabled)}
                      onChange={() => toggleRule(rule)}
                    />
                  </td>

                  <td className="p-3 text-right">
                    <div className="flex justify-end gap-3">
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            `/helpdesk/automation/rules/${rule.id}`
                          )
                        }
                        className="text-blue-600"
                      >
                        Edit
                      </button>

                      <button
                        type="button"
                        onClick={() => deleteRule(rule)}
                        className="text-red-600"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}